import { render, staticRenderFns } from "./SocialPostsTableBiensVendus.vue?vue&type=template&id=6179c9e4&scoped=true&"
import script from "./SocialPostsTableBiensVendus.vue?vue&type=script&lang=js&"
export * from "./SocialPostsTableBiensVendus.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostsTableBiensVendus.vue?vue&type=style&index=0&id=6179c9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6179c9e4",
  null
  
)

export default component.exports